import { Component, OnInit } from '@angular/core';
import { UserData } from '../../_models/users';
import { ActivatedRoute, Params } from '@angular/router';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../_services/api.service';
import { ChecksService } from '../../_services/checks.service';
import { EncrDecrService } from '../../_services/encode.decode.service';
import { NotificationService } from '../../_services/notification.service';
import { AdminData } from '../../_models/admin';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrl: './details.component.css'
})
export class DetailsComponent implements OnInit {
  routeParams: Params;
  queryParams: Params;

  kycUrl = environment.kycUrl;

  id: number;

  processing: boolean = false;
  loading: boolean = true;
  
  userData: UserData;
  adminData: AdminData;

  companyDetails: boolean = true;
  directorDetails: boolean = false;
  contactPersonDetails: boolean = false;
  ownershipDetails: boolean = false;
  transactionDetails: boolean = false;
  complianceDetails: boolean = false;
  uploadFiles: boolean = false;

  companyDetailsComplete: boolean = false;
  directorDetailsComplete: boolean = false;
  ownershipDetailsComplete: boolean = false;
  contactPersonDetailsComplete: boolean = false;
  transactionDetailsComplete: boolean = false;
  complianceDetailsComplete: boolean = false;
  uploadFilesComplete: boolean = false;

  approveLabel: string;
  approveLabelDesc: string;
  action: string;
  actionid: number;

  publicKey: string = localStorage.getItem('publicKey');

  dataForm = this.fb.group({
    comment: ["", Validators.maxLength(1000)]
  }, {});
Object: any;
  get comment() { return this.dataForm.get('comment'); }

  constructor(
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    public checkService: ChecksService,
    private apiService: ApiService,
    private notifyService: NotificationService,
    private EncrDecr: EncrDecrService,
    private http: HttpClient
  ) {
    this.checkService.checkSession();
    this.getRouteParams();
  }

  ngOnInit(): void {
    if (this.routeParams['id'] !== undefined) {
      this.id = this.routeParams['id'];
    }

    this.getOneUser(this.id);
    this.adminData = this.checkService.getAdminData();
  }

  printUserInfo(url: string) {
  this.http.get(url, { responseType: 'blob' })
    .subscribe((blob: Blob) => {
      const fileURL = URL.createObjectURL(blob);

      // Create a hidden iframe
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = fileURL;
      document.body.appendChild(iframe);

      iframe.onload = () => {
        iframe.contentWindow?.focus();
        iframe.contentWindow?.print();

        // Remove iframe after short delay (cleanup)
        setTimeout(() => {
          document.body.removeChild(iframe);
          URL.revokeObjectURL(fileURL);
        }, 20000);
      };
    });
}

  getOneUser(page:number) {
    this.loading = true;

    this.apiService.getOneUser(page).subscribe(
      data => {
        this.checkService.checkLoggedin(data);
        this.loading = false
        if (data.success == true) {
          this.userData = data.data;
          this.getValidateStatus();
        } else {
          this.notifyService.showError(data.error.message, "Error")
        }
      }
    );

  }

  getValidateStatus() {
    let userData = this.userData.validation;
    if (userData.companyDetails.status.approved === true) {
      this.companyDetailsComplete = true;
    }
    if (userData.directorDetails.status.approved === true) {
      this.directorDetailsComplete = true;
    }
    if (userData.ownershipDetails.status.approved === true) {
      this.ownershipDetailsComplete = true;
    }
    if (userData.contactPersonDetails.status.approved === true) {
      this.contactPersonDetailsComplete = true;
    }
    if (userData.transactionDetails.status.approved === true) {
      this.transactionDetailsComplete = true;
    }
    if (userData.complianceDetails.status.approved === true) {
      this.complianceDetailsComplete = true;
    }
    if (userData.uploadFiles.status.approved === true) {
      this.uploadFilesComplete = true;
    }
  }

  getRouteParams() {
    // Route parameters
    this.activatedRoute.params.subscribe( params => {
        this.routeParams = params;
    });

    // URL query parameters
    this.activatedRoute.queryParams.subscribe( params => {
        this.queryParams = params;
    });

    // URL get change
    this.activatedRoute.url.subscribe(url =>{
      this.ngOnInit();
    });
  }

  jump( tab: string = ''): void {
    if (tab == "companyDetails") {
      this.companyDetails = true;
      this.directorDetails = false;
      this.contactPersonDetails = false;
      this.ownershipDetails = false;
      this.transactionDetails = false;
      this.complianceDetails = false;
      this.uploadFiles = false;
    } else if (tab == "directorDetails") {
      this.companyDetails = false;
      this.directorDetails = true;
      this.contactPersonDetails = false;
      this.ownershipDetails = false;
      this.transactionDetails = false;
      this.complianceDetails = false;
      this.uploadFiles = false;
    } else if (tab == "contactPersonDetails") {
      this.companyDetails = false;
      this.directorDetails = false;
      this.contactPersonDetails = true;
      this.ownershipDetails = false;
      this.transactionDetails = false;
      this.complianceDetails = false;
      this.uploadFiles = false;
    } else if (tab == "ownershipDetails") {
      this.companyDetails = false;
      this.directorDetails = false;
      this.contactPersonDetails = false;
      this.ownershipDetails = true;
      this.transactionDetails = false;
      this.complianceDetails = false;
      this.uploadFiles = false;
    } else if (tab == "transactionDetails") {
      this.companyDetails = false;
      this.directorDetails = false;
      this.contactPersonDetails = false;
      this.ownershipDetails = false;
      this.transactionDetails = true;
      this.complianceDetails = false;
      this.uploadFiles = false;
    } else if (tab == "complianceDetails") {
      this.companyDetails = false;
      this.directorDetails = false;
      this.contactPersonDetails = false;
      this.ownershipDetails = false;
      this.transactionDetails = false;
      this.complianceDetails = true;
      this.uploadFiles = false;
    } else if (tab == "uploadFiles") {
      this.companyDetails = false;
      this.directorDetails = false;
      this.contactPersonDetails = false;
      this.ownershipDetails = false;
      this.transactionDetails = false;
      this.complianceDetails = false;
      this.uploadFiles = true;
    } else {
      this.companyDetails = true;
      this.directorDetails = false;
      this.contactPersonDetails = false;
      this.ownershipDetails = false;
      this.transactionDetails = false;
      this.complianceDetails = false;
      this.uploadFiles = false;
    }
  }

  modalApprove(className: string, classId:number, label:string) {
    if (className == "UserCompanyDetails") {
      this.approveLabel = "Company Details";
    } else if (className == "UserDirector") {
      this.approveLabel = "Principal Officers";
    } else if (className == "UserContact") {
      this.approveLabel = "Contact Details";
    } else if ((className == "UserBankAccount") || (className == "UserRelatedEntity") || (className == "UserInternationalB") || (className == "UserLocalBranch") || (className == "UserOwner")) {
      this.approveLabel = "Ownerships and Account";
    } else if (className == "UserTransactionDetails") {
      this.approveLabel = "Transaction Details";
    } else if (className == "UserCompliance") {
      this.approveLabel = "Compliance Details";
    } else if (className == "UserDocument") {
      this.approveLabel = "Uploaded Document";
    }
    this.approveLabelDesc = (label !== null)? label : this.approveLabel;

    this.action = className;
    this.actionid = classId;
  }

  approve(action: string, id:number) {
    var data: object = {
      ref: this.userData.ref,
      class: action,
      class_id: id,
      user_id: this.userData.ref,
      value: 1,
    };

    this.submitApproval(data);
  }

  reject(action: string, id:number) {
    var data: object = {
      ref: this.userData.ref,
      class: action,
      class_id: id,
      user_id: this.userData.ref,
      comment: this.dataForm.value.comment,
      value: 2,
    };

    this.submitApproval(data, 2);
  }

  submitApproval(data, action = 1) {
    this.apiService.submitApproval(data).subscribe(
      user => {
        this.processing = false
        if (user.success == true) {
          this.ngOnInit();
          document.getElementById('modal-approve').click();
          document.getElementById('modal-reject').click();
          document.getElementById('modal-approve-kyc').click();
          if (action == 1) {
            this.notifyService.showSuccess("User KYC data approved", "KYC Data");
          } else {
            this.notifyService.showSuccess("User KYC data rejected", "KYC Data");
          }
        } else {
          this.notifyService.showError(user.error.message + ". " + user.error.additional_message, "Error")
        }
      }
    );
  }

  activate(action: string) {
    var data: object = {
      ref: this.userData.ref
    };

    this.activateProfile(data);
  }

  activateProfile(data) {
    this.apiService.activateProfile(data).subscribe(
      user => {
        this.processing = false
        if (user.success == true) {
          document.getElementById('modal-approve').click();
          document.getElementById('modal-reject').click();
          document.getElementById('modal-approve-kyc').click();
          this.notifyService.showSuccess("User KYC data approved", "KYC Data");
          this.ngOnInit();
        } else {
          this.notifyService.showError(user.error.message + ". " + user.error.additional_message, "Error")
        }
      }
    );
  }

  cleanTitle(title, label) {
    if (label !== undefined && label != "") {
      var myarray = label.split('|');
      var re = /_/gi; 
      var user = "";
      if (myarray[1] !== undefined) {
        user = myarray[1].replace(re, " ");
      }

      return (title + " " + user).trim();
    }

    return title;
  }
  
  isNotEmpty(obj: any): boolean {
    return Object.keys(obj).length > 0;
  }

  printName(details:UserData) {
    return (details.companyDetails.ref == 0)? details.firstName + " " + details.lastName : details.companyDetails.name
  }
}
